"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.shouldRefreshSmallTownsList = exports.logSmallTownsListRefreshReason = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _superagent = _interopRequireDefault(require("superagent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var logSmallTownsListRefreshReason = function logSmallTownsListRefreshReason(data, s3configFiles) {
  console.log('**************************************');
  console.log('* SEOMANAGER download smallTownsList *');
  console.log('*                                    *');

  if (!data) {
    console.log('* reason: list doesn\'t exist         *');
  } else if (data.error) {
    console.log('* reason: previous attempt failed    *');
  } else {
    console.log('* reason: list is outdated           *');
  }

  console.log('*                                    *');
  console.log('**************************************');
};

exports.logSmallTownsListRefreshReason = logSmallTownsListRefreshReason;

var shouldRefreshSmallTownsList = function shouldRefreshSmallTownsList(updateDt) {
  if (!updateDt) {
    return true;
  }

  var diffInMinutes = Math.abs(Math.round((new Date().getTime() - updateDt) / 60000));

  if (diffInMinutes > 1440) {
    // 1 giorno
    return true;
  }

  return false;
};

exports.shouldRefreshSmallTownsList = shouldRefreshSmallTownsList;

var _default = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(s3configFiles) {
    var clb,
        smallTownsListS3,
        lastUpdate,
        parsed,
        s3Data,
        status,
        body,
        headers,
        towns,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            clb = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
            smallTownsListS3 = "".concat(s3configFiles, "/config/web/towns.json?cacheBuster=").concat(new Date().getTime());
            lastUpdate = '';
            parsed = [];
            _context.prev = 4;
            _context.next = 7;
            return _superagent["default"].get(smallTownsListS3).accept('json').buffer(true).parse(_superagent["default"].parse.image);

          case 7:
            s3Data = _context.sent;
            status = s3Data.status, body = s3Data.body, headers = s3Data.headers;

            if (status === 200) {
              towns = JSON.parse(body.toString());
              Object.keys(towns).forEach(function (town) {
                var townObj = towns[town];

                if (townObj.smallTown) {
                  parsed.push(town);
                }
              });
              lastUpdate = new Date(headers['last-modified']).getTime();
            }

            _context.next = 15;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](4);
            console.error("./helpers/getSmallTownsList error: ".concat(_context.t0, ", file domain: ").concat(s3configFiles));

          case 15:
            return _context.abrupt("return", clb ? clb(parsed) // /src/_scripts/small_towns.js -> genera il file statico usando solo la lista, imposta error sempre a true e non ha bisogno di timestamp
            : {
              // checkIfSmallTown in /src/utils/helpers.js -> popola la variabile globale SM__SMALLTOWNS__DATA
              updateDt: lastUpdate,
              townsConfig: parsed,
              error: !parsed.length
            });

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 12]]);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();

exports["default"] = _default;